export default __webpack_public_path__ + "static/media/logo-paypal.7f2c798b.svg";